import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

function SentLikes() {
  const [sentLikes, setSentLikes] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const { token, logout } = useAuth();

  useEffect(() => {
    async function fetchSentLikes() {
      if (!token) {
        setError("You must be logged in to view sent likes.");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const response = await axios.get(
          "/api/likes/sent",
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        console.log("Sent likes:", response.data);

        setSentLikes(response.data);
      } catch (err) {
        console.error("Sent likes error:", err);

        if (err.response && err.response.status === 401) {
          logout();
          setError("Session expired. Please login again.");
        } else if (err.response && err.response.data) {
          setError(err.response.data);
        } else {
          setError("Failed to load sent likes.");
        }
      } finally {
        setLoading(false);
      }
    }

    fetchSentLikes();
  }, [token, logout]);

  if (loading) {
    return (
      <div>
        <h1>Sent Likes</h1>
        <p>Loading sent likes...</p>
      </div>
    );
  }

  return (
    <div>
      <h1>Sent Likes</h1>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {sentLikes.length === 0 && !error && (
        <p>You have not sent any pending likes.</p>
      )}

      <div>
        {sentLikes.map((user) => (
          <div
            key={user.id}
            style={{
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "15px",
              marginBottom: "15px",
              maxWidth: "500px"
            }}
          >
            {user.photoUrl && (
              <img
                src={user.photoUrl}
                alt={user.username}
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginBottom: "10px"
                }}
                onError={(event) => {
                  event.currentTarget.style.display = "none";
                }}
              />
            )}

            <h2>{user.username}</h2>

            <p>
              <strong>Age:</strong> {user.age}
            </p>

            <p>
              <strong>Gender:</strong> {user.gender}
            </p>

            {(user.country || user.city) && (
              <p>
                <strong>Location:</strong>{" "}
                {[user.city, user.country].filter(Boolean).join(", ")}
              </p>
            )}

            <p>
              <strong>Bio:</strong> {user.bio}
            </p>

            <p style={{ color: "#666" }}>
              Waiting for this user to like you back.
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SentLikes;
